import { render, staticRenderFns } from "./bar-chart-icon.vue?vue&type=template&id=35cf258d&scoped=true"
import script from "./bar-chart-icon.vue?vue&type=script&lang=js"
export * from "./bar-chart-icon.vue?vue&type=script&lang=js"
import style0 from "./bar-chart-icon.vue?vue&type=style&index=0&id=35cf258d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf258d",
  null
  
)

export default component.exports